
import { computed, ref } from "vue";
import { Options } from "vue-class-component";
import BaseElement from "../BaseElement.vue";

@Options({
  emits: ["focus", "blur", "change"]
})
export default class IziInput extends BaseElement {
  input = ref(this.value);
  public bindingClass = computed(() => this.class);

  getIconPos = computed(() =>
    !this.iconPos ? "" : `p-input-icon-${this.iconPos}`
  );

  handleInput(value: any) {
    this.$emit("update:value", value);
  }

  handleBlur() {
    this.$emit("blur");
  }

  handleForcus() {
    this.$emit("focus");
    this.$emit("update:msg", "");
  }
}
